import Error from "./Error";
import { useEffect, useState } from "react"
import API from "../../../services/API"
import Loader from "../../Tools/Loader";

export default function Html({section}){

    const [url, setUrl] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {

        API.get(`/study/sections/${section.id}/doc.html`)
            .then(r => {
                let blob = new Blob([r.data], {type: "text/html"});
                let url = window.URL.createObjectURL(blob);
                return setUrl( url )
            })
            .catch(e => setError(true))

        return () => {
            setUrl(null)
            setError(false)
        }

    }, [section])


    if(error) return <Error />


    return url ? 
        <iframe
            id={section.id}
            title={section.title}
            src={url} 
            width="100%"
            height="99%"
            frameBorder="0"
            allow="autoplay; fullscreen"
        >
        </iframe>
        : 
        <Loader />
}
